import { render } from "./what.vue?vue&type=template&id=fed37c94&lang=pug"
import script from "./what.vue?vue&type=script&lang=js"
export * from "./what.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__